import { findIndex } from "lodash-es";

const inProgressStatuses = ["New", "In Progress"];

export function getNavigationUrl(encounter) {
    return getNavigationUrlForEncounter(encounter.globalId, encounter.status);
}

export function getNavigationUrlByEncounterId(encounterId, encounterStatus, goToDispatch = false) {
    return getNavigationUrlForEncounter(encounterId, encounterStatus, goToDispatch);
}

function getNavigationUrlForEncounter(encounterId, encounterStatus, goToDispatch = false) {
    if (inProgressStatuses.indexOf(encounterStatus) >= 0) {
        return `/interview/${encounterId}`;
    } else if (encounterStatus === "Pending") {
        return `/interview/${encounterId}/details/marketplace`;
    } else if (encounterStatus === "Pending Decision") {
        return `/interview/${encounterId}/details/approval`;
    } else if (encounterStatus === "Complete" || encounterStatus === "Closed") {
        if (goToDispatch === true) {
            return `/interview/${encounterId}/details/dispatch`;
        }
        return `/interview/${encounterId}/details/facesheet`;
    } else {
        throw new Error(`Unknown encounter status: ${encounterStatus} for encounter: ${JSON.stringify(encounterId)}`);
    }
}
